<template>
  <svg class="hadrian-icons mixed-toilet" xmlns="http://www.w3.org/2000/svg" width="52" height="40" viewBox="0 0 52 40">
    <defs>
      <filter id="ecbu2h138a">
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 0.278431 0 0 0 0 0.541176 0 0 0 0 0.745098 0 0 0 1.000000 0"
        />
      </filter>
    </defs>
    <g>
      <g>
        <g>
          <g>
            <g>
              <path
                d="M4.021 28.993l2.757-15.725.007-.049c-.005-.177-.145-.32-.32-.32-.173 0-.313.143-.322.32L2.968 23.97c-.178.998-.662 1.508-1.477 1.508-.814 0-1.618-.676-1.474-1.506l3.637-12.438C4 9.334 5.446 8 7.238 8h8.17c1.867 0 3.259 1.333 3.62 3.278l3.636 12.697-.014.004c.144.832-.662 1.506-1.475 1.506-.814 0-1.297-.51-1.476-1.508-.009-.049-.002-.092-.007-.139l-3.146-10.606c0-.181-.144-.328-.321-.328-.176 0-.314.143-.324.32v.019l2.761 15.752h-2.688c.01.138.016.279.016.422.005 2.362.008 4.637.01 6.69v1.972C16 39.14 15.125 40 14.045 40s-1.956-.86-1.956-1.92l-.011-9.086-.844-.001.011 9.086c0 1.01-.794 1.839-1.803 1.915L9.289 40c-1.08 0-1.955-.86-1.955-1.92v-8.894c0-.066 0-.13.002-.194H4.02zM14.667 3.334c0 1.84-1.493 3.333-3.334 3.333C9.493 6.667 8 5.175 8 3.334 8 1.493 9.493 0 11.333 0c1.841 0 3.334 1.493 3.334 3.334"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M15.942 11.62c-.01-1.996-1.67-3.62-3.7-3.62H3.758c-2.03 0-3.69 1.624-3.7 3.62L0 22.92c-.004.85.692 1.541 1.555 1.545h.008c.86 0 1.56-.683 1.564-1.53l.057-10.17c.01-.186.169-.33.358-.324.188.005.338.157.338.342l.001 25.373c0 1.019.84 1.845 1.876 1.845s1.876-.826 1.876-1.845V22.737h.81v15.418c0 1.019.84 1.845 1.876 1.845s1.876-.826 1.876-1.845c0-6.91-.032-18.224-.034-25.385 0-.178.145-.321.325-.322.18-.002.327.14.33.316l.057 10.17c.005.847.704 1.53 1.563 1.53h.008c.864-.004 1.56-.696 1.556-1.545l-.058-11.298zM11.333 3.334c0 1.84-1.492 3.333-3.333 3.333-1.84 0-3.333-1.492-3.333-3.333C4.667 1.493 6.159 0 8 0c1.841 0 3.333 1.493 3.333 3.334"
                transform="translate(36)"
              />
            </g>
          </g>
        </g>
        <path
          d="M28.722 0c.27 0 .497.188.556.44l.015.131V39.43c0 .315-.256.571-.571.571-.27 0-.497-.188-.557-.44l-.015-.131V.57c0-.315.256-.571.572-.571z"
        />
      </g>
    </g>
  </svg>
</template>
